<template>
  <b-card class="h-100">
    <b-card-title class="mb-4">Notifications</b-card-title>
    <div v-if="loaded && lengthNotOpened > 0" class="overflow-auto" style="height: 90%">
      <div v-for="(notification, index) in notifications" :key="index" class="cursor-pointer mb-4" @click="goTo(index)">
        <b-row v-if="!notification.opened" class="mx-1">
          <b-col cols="12">
            <h6>
              {{ notification.verb }}
            </h6>
            <b-row class="text-semi-light mt-3">
              <b-col cols="6">
                {{ notification.created_at | formatDate }}
              </b-col>
              <b-col class="d-flex justify-content-end" cols="6">
                <div>
                  <i class="mdi mdi-account"></i>
                  {{ notification.actor_object.first_name }} {{ notification.actor_object.last_name }}
                </div>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </div>
    </div>
    <h-e-spinner v-if="!loaded"></h-e-spinner>
    <h4 v-if="lengthNotOpened === 0 && loaded" class="text-primary text-center">Vous n'avez pas de notification</h4>
  </b-card>
</template>

<script>
import { APIRequest } from '@/node-sdk'
import moment from 'moment'

export default {
  name: 'notification',

  data() {
    return {
      notifications: [],
      loaded: false,
      lengthNotOpened: 0,
    }
  },

  filters: {
    formatDate: function (date) {
      return moment(date).format('DD/MM/YYYY')
    },
  },

  mounted() {
    this.getNotifications()
  },

  methods: {
    getNotifications() {
      let self = this
      APIRequest.get_with_request(process.env.VUE_APP_NOTIFICATIONS_API, 'notifications', '').then(function (datas) {
        self.notifications = datas[0]
        for (let i = 0; i < self.notifications.length; i++) {
          if (!self.notifications[i].opened) {
            self.lengthNotOpened++
          }
        }
        self.loaded = true
      })
    },

    getUserMe() {
      return JSON.parse(localStorage.getItem('user_object')).uuid
    },

    async goTo(index) {
      this.notifications[index].opened = true
      await APIRequest.edit(
        process.env.VUE_APP_NOTIFICATIONS_API,
        'notifications',
        this.notifications[index].id,
        this.notifications[index],
      )
      await this.$router.push(this.notifications[index].action)
    },
  },
}
</script>

<style scoped></style>
